import { createStart } from "@tanstack/react-start";
import { requestContextMiddleware } from "@/middleware/request-context";
import { infraMeteringMiddleware } from "@/middleware/infra-metering";
import { apiCsrfMiddleware } from "@/middleware/api-csrf";
import { perfTraceMiddleware } from "@/middleware/perf-trace";
import { tenantHostSlugMiddleware } from "@/middleware/tenant-host-slug";
import { apiTraceSpanMiddleware } from "@/middleware/api-trace-span";
import { assertProductionSecrets } from "@/lib/env-guards";

// Fail-fast: verifica secretos críticos al arrancar el servidor
assertProductionSecrets();

export const startInstance = createStart(() => ({
  // tenantHostSlug antes del router rewrite: llena ALS para home + deep links
  // perfTrace primero para medir wall-clock total; request-context agrega requestId
  requestMiddleware: [
    perfTraceMiddleware,
    tenantHostSlugMiddleware,
    requestContextMiddleware,
    apiTraceSpanMiddleware,
    infraMeteringMiddleware,
    apiCsrfMiddleware,
  ],
}));
